module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic04.c315976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic04.png
// module id = 504
// module chunks = 1